import { usedStampsRepo } from "./usedStamps.repo";
import {
  GetListaIskoriscenihAMPayload,
  IEvidentiranjeMarkicaPayload,
  IPonistiEvidentiraniOpsegPayload,
  StavljanjeMarkicaUPrometPayload,
} from "./usedStamps.types";

class UsedStampsService {
  createEvidentiranjeMarkica = (payload: IEvidentiranjeMarkicaPayload) => {
    return usedStampsRepo.createEvidentiranjeMarkica(payload);
  };

  getListaIskoriscenihAkciznihMarkica = (
    payload: GetListaIskoriscenihAMPayload
  ) => {
    return usedStampsRepo.getListaIskoriscenihAkciznihMarkica(payload);
  };

  postStavljanjeMarkicaUPromet = (payload: StavljanjeMarkicaUPrometPayload) => {
    return usedStampsRepo.postStavljanjeMarkicaUPromet(payload);
  };

  postPonistiEvidentiraniOpseg = (
    payload: IPonistiEvidentiraniOpsegPayload
  ) => {
    return usedStampsRepo.postPonistiEvidentiraniOpseg(payload);
  };
}

export const usedStampsService = new UsedStampsService();
